import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return (
    <span ref={ref} className="tabular-nums">
      {n.toLocaleString()}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" className="py-20 md:py-28 px-6 md:px-12">
    <div className="max-w-[1600px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
      <Reveal className="border-l border-[#e4e4e7] pl-6">
        <div data-testid="stat-0" className="font-head text-6xl md:text-7xl xl:text-8xl tracking-tighter">
          <Counter value={15} suffix="+" />
        </div>
        <p className="font-body text-sm text-[#52525b] mt-3 uppercase tracking-wide">
          Years of international recruitment experience
        </p>
      </Reveal>
      <Reveal delay={0.08} className="border-l border-[#e4e4e7] pl-6">
        <div data-testid="stat-1" className="font-head text-6xl md:text-7xl xl:text-8xl tracking-tighter">
          <Counter value={35000} suffix="+" />
        </div>
        <p className="font-body text-sm text-[#52525b] mt-3 uppercase tracking-wide">
          Candidates advised
        </p>
      </Reveal>
      <Reveal delay={0.16} className="border-l border-[#e4e4e7] pl-6">
        <div data-testid="stat-2" className="font-head text-4xl md:text-5xl xl:text-6xl tracking-tight leading-none pt-2">
          Europe-focused
        </div>
        <p className="font-body text-sm text-[#52525b] mt-3 uppercase tracking-wide">
          Recruitment expertise
        </p>
      </Reveal>
      <Reveal delay={0.24} className="border-l border-[#e4e4e7] pl-6">
        <div data-testid="stat-3" className="font-head text-4xl md:text-5xl xl:text-6xl tracking-tight leading-none pt-2">
          International
        </div>
        <p className="font-body text-sm text-[#52525b] mt-3 uppercase tracking-wide">
          B2B network
        </p>
      </Reveal>
    </div>
  </section>
);
